var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilding07(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24984 9.16667H3.83317C3.36646 9.16667 3.13311 9.16667 2.95485 9.25749C2.79804 9.33739 2.67056 9.46487 2.59067 9.62167C2.49984 9.79993 2.49984 10.0333 2.49984 10.5V17.5M13.7498 9.16667H16.1665C16.6332 9.16667 16.8666 9.16667 17.0448 9.25749C17.2016 9.33739 17.3291 9.46487 17.409 9.62167C17.4998 9.79993 17.4998 10.0333 17.4998 10.5V17.5M13.7498 17.5V5.16667C13.7498 4.23325 13.7498 3.76654 13.5682 3.41002C13.4084 3.09641 13.1534 2.84144 12.8398 2.68166C12.4833 2.5 12.0166 2.5 11.0832 2.5H8.9165C7.98308 2.5 7.51637 2.5 7.15985 2.68166C6.84625 2.84144 6.59128 3.09641 6.43149 3.41002C6.24984 3.76654 6.24984 4.23325 6.24984 5.16667V17.5M18.3332 17.5H1.6665M9.1665 5.83333H10.8332M9.1665 9.16667H10.8332M9.1665 12.5H10.8332",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding07);
export default __webpack_public_path__ + "static/media/building-07.090e20d2e15efb35474b13984cd74aaa.svg";
export { ForwardRef as ReactComponent };